module.exports = __webpack_public_path__ + "static/media/38.5d90aa9e.png";